<script>
import { mapActions } from "vuex";

export default {
  title: "Editar telefone",
  props: {
    phone: {
      type: Object,
      required: true
    },
    dialog: {
      Type: Boolean,
      required: true
    }
  },
  methods: {
    ...mapActions("phones", ["updatePhone", "deletePhone"]),
    ...mapActions("snackbar", ["snackbarSuccess"]),

    async deleteCurrentPhone() {
      this.deleteLoader = true;

      try {
        await this.deletePhone(this.phone.id);
        this.snackbarSuccess("Telefone deletado com sucesso");
      } catch (e) {
        this.$toast.error("Nao foi posivel deletar o telefone!");
      }

      this.deleteLoader = false;
      this.emitClose();
      this.emitRefresh();
    },
    async saveCurrentPhone() {
      this.saveLoader = true;

      try {
        await this.updatePhone({
          data: {
            area_code: this.areaCode,
            number: this.number
          },
          phoneId: this.phone.id
        });
        this.snackbarSuccess("Telefone Atualizado com sucesso");
      } catch (e) {
        this.$toast.error("Nao foi possivel atualizar o telefone!");
      }

      this.saveLoader = false;
      this.emitClose();
      this.emitRefresh();
    },
    emitRefresh() {
      this.$emit("refresh");
    },
    emitClose() {
      this.$emit("close");
    }
  },
  data() {
    return {
      deleteLoader: false,
      saveLoader: false,
      number: this.phone.number,
      areaCode: this.phone.area_code
    };
  }
};
</script>

<template>
  <v-dialog v-model="dialog" max-width="500px" @click:outside="emitClose()">
    <v-card>
      <v-card-title>
        <span class="headline">Alterar telefone</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="areaCode"
                label="DDD (Codigo de area)"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="number"
                label="Telefone"
                v-mask="'#########'"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="group-buttons">
        <div>
          <v-btn
            color="red"
            text
            @click="deleteCurrentPhone()"
            :loading="deleteLoader"
          >
            Deletar
          </v-btn>
        </div>
        <div>
          <v-btn color="primary" text @click="emitClose()">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="saveCurrentPhone()"
            :loading="saveLoader"
          >
            Salvar
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.group-buttons {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Account/Phones/Update.vue